import { ApiResponse } from 'apisauce';
import { Team } from '../../../modules/context/ApplicationContext/applicationContext.types';
import { restApi } from '../../api';
import {
  BrandShowroom,
  BrandShowroomAbout,
  BrandShowroomBanner,
  BrandShowroomContact,
} from './brand-showroom.types';

export const brandShowroomRepository = () => {
  const repository = {
    saveAbout: (data: BrandShowroomAbout) => restApi.patch(`showroom/about`, data),
    saveBanner: (data: BrandShowroomBanner) => restApi.patch(`showroom/banner`, data),
    saveContact: (data: BrandShowroomContact) => restApi.patch(`showroom/contact`, data),
    getContacts: (brandId: string) =>
      restApi.get<ApiResponse<Team[], void>>(`showroom/${brandId}/contacts-showcase`),
    get: (slug: string) => restApi.get<BrandShowroom>(`showroom/${slug}`),
  };
  return repository;
};
